import { useEffect, useState } from 'react'

import { SEARCH_API_UNSET, SEARCH_TIMEOUT } from '../Search.constants'

import { useSearchApi } from './useSearchApi'

/**
 * @typedef {SearchListValue<TItem>[] | null} SearchApiState
 * @template {object} TItem
 */

/**
 * @template {object} TItem - A type of item which search API returns
 *
 * @param {SearchValue} search
 * @param {SearchConfig<TItem> | null} config
 * @param {number} [timeout]
 *
 * @returns {SearchListValue<TItem> | null}
 */
export function useSearchListValue(search, config, timeout = SEARCH_TIMEOUT) {
  const searchApi = useSearchApi(search, config, timeout)

  const [value, setValue] = useState(null)
  const [prevSearchApi, setPrevSearchApi] = useState(SEARCH_API_UNSET)

  // Clear items (or reset to null) during render whenever the search API
  // changes; the matching request runs in the effect below.
  if (searchApi !== prevSearchApi) {
    setPrevSearchApi(searchApi)
    setValue(searchApi ? currValue => ({ ...currValue, items: null }) : null)
  }

  useEffect(() => {
    if (searchApi) {
      searchApi
        .call()
        .then(setValue)
        .catch(() => setValue(null))
    }
  }, [searchApi])

  return value
}
